import React, { Component } from 'react';
import { 
  Card,
  CardHeader,
  CardBody
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUsers,
  faYenSign,
  faHome,
  faShoppingCart
} from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

class CoreInsightCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coreInsight: null 
    };
  }

  componentDidMount() {
    const { coreInsightId } = this.props;

    fetch('/api/core_insights/' + coreInsightId).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ coreInsight: respJson }); 
      });
  }

  getCategoryIcon(category) {
    let icon = null;

    switch(category) {
      case "Demographic": icon = faUsers;
                          break;
      case "Economic":    icon = faYenSign;
                          break;
      case "Retail":      icon = faShoppingCart;
                          break;
      case "Social & Wellness":      icon = faHome;
                          break;
      default:            break;
    }  

    return icon;
  }

  render() {
    const { coreInsight } = this.state;

    return (
      <Card className="mb-3">
        <CardHeader className="bg-primary text-white">
          { coreInsight ? 
            <div>
              <span className="fa-layers fa-fw mr-2">
                <FontAwesomeIcon icon={faCircle} transform="grow-10" />
                <FontAwesomeIcon 
                  icon={this.getCategoryIcon(coreInsight.category)} 
                  transform="shrink-4" />
              </span>
              {coreInsight.category}
              <br/>
              <h5 className="mt-1">{coreInsight.name}</h5>
            </div>
          : null }
        </CardHeader>
        <CardBody>{coreInsight ? coreInsight.content : null}</CardBody>
      </Card>
    ); 
  }
}

export default CoreInsightCard;
